"use client";

import * as React from "react";
import * as SliderPrimitive from "@radix-ui/react-slider";

import { cn } from "@/lib/utils";

const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root> & {
    showValue?: (value: number) => string;
  }
>(({ className, showValue, ...props }, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    className={cn(
      "group relative flex w-full touch-none select-none items-center data-[disabled]:opacity-60 data-[disabled]:cursor-not-allowed",
      className
    )}
    {...props}
  >
    <SliderPrimitive.Track className="relative h-1 w-full  grow overflow-hidden rounded-full bg-border cursor-pointer data-[disabled]:cursor-not-allowed">
      <SliderPrimitive.Range className="absolute h-full bg-primary" />
    </SliderPrimitive.Track>
    <SliderPrimitive.Thumb className="relative block h-4 w-4 cursor-pointer rounded-full border !border-[#FFFFFF] bg-primary transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring data-[disabled]:pointer-events-none">
      {showValue && props.value?.[0] != null && (
        <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-1.5 bg-primary text-primary-foreground text-xs px-2 py-1 rounded shadow-sm whitespace-nowrap pointer-events-none opacity-0 transition-opacity group-active:opacity-100 group-focus-within:opacity-100">
          {showValue(props.value[0])}
        </span>
      )}
    </SliderPrimitive.Thumb>
  </SliderPrimitive.Root>
));
Slider.displayName = SliderPrimitive.Root.displayName;

const RangeSlider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root> & {
    showValue?: (value: number) => string;
  }
>(({ className, showValue, ...props }, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    className={cn(
      "relative flex w-full touch-none select-none items-center data-[disabled]:opacity-60 data-[disabled]:cursor-not-allowed",
      className
    )}
    {...props}
  >
    <SliderPrimitive.Track className="relative h-1 w-full grow overflow-hidden rounded-full bg-border cursor-pointer data-[disabled]:cursor-not-allowed">
      <SliderPrimitive.Range className="absolute h-full bg-primary" />
    </SliderPrimitive.Track>
    {(props.value ?? props.defaultValue ?? []).map((thumbValue, i) => (
      <SliderPrimitive.Thumb
        key={i}
        className="relative block h-4 w-4 cursor-pointer rounded-full border !border-[#FFFFFF] bg-primary transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring data-[disabled]:pointer-events-none"
      >
        {showValue && (
          <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-1.5 bg-primary text-primary-foreground text-xs px-2 py-1 rounded shadow-sm whitespace-nowrap pointer-events-none">
            {showValue(thumbValue)}
          </span>
        )}
      </SliderPrimitive.Thumb>
    ))}
  </SliderPrimitive.Root>
));
RangeSlider.displayName = "RangeSlider";

export { Slider, RangeSlider };
